<template>
    <div>
        <v-row v-if="currentDocument" class="pa-4">            
            <v-col :cols="show_retention_type_name?'3':'6'">
                <metadata-field-detected 
                    field-key="retention_type" 
                    :required="Boolean(currentDocument.metadata['retention_amount'])" 
                    :tabs="tabs" 
                    kind="number" 
                    field-text="% Ret." 
                    :key="currentDocument.id.toString()+isWaitingFlow.toString()+'retention_type'"
                    readonly
                />
            </v-col>
            <v-col :cols="show_retention_type_name?'3':'6'">
                <metadata-field-detected 
                    field-key="retention_amount" 
                    :required="Boolean(currentDocument.metadata['retention_type'])" 
                    :tabs="tabs" 
                    kind="number" 
                    field-text="Retención" 
                    :key="currentDocument.id.toString()+isWaitingFlow.toString()+'retention_amount'"
                    readonly
                />
            </v-col>
        </v-row>
        <v-tabs v-model="currentTab">
            <v-tab 
                v-for="tab in visibleTabs" 
                :key="tab.code"
            >
                <div v-if="tab.code == 'params'" >
                    {{tab.text}} <v-icon v-if="someParamsError" color="red">mdi-alert</v-icon>
                </div>
                <div v-else>
                    {{tab.text}}
                </div>
            </v-tab>
        </v-tabs> 
        <v-tabs-items v-model="currentTab" v-if="currentDocument" class="ma-3 table-iva">
            <v-tab-item
                :key="tab.tab"
                v-for="tab in visibleTabs"
            >
                <div v-if="tab.code == 'params'" >
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-row v-if="got_feature('feature_serie_in_docs')">
                                <v-col cols="8">
                                    <doc-text-field 
                                        kind="text" 
                                        @change="setDirty()"
                                        v-model="document_serie" 
                                        label="Serie"
                                        readonly
                                    />
                                </v-col>
                            </v-row>
                            <v-divider role="separator" aria-orientation="horizontal" class="v-divider theme--light"/>
                        </v-col>
                    </v-row>
                </div>
                <v-row v-else no-gutters>
                                     
                    <template v-if="currentDocument.companydb_info && currentDocument.companydb_info.companydb_type && currentDocument.companydb_info.companydb_type.type == 'invoice' && currentDocument.companydb_info.companydb_type.params && currentDocument.companydb_info.companydb_type.params.desglose_de_cuentas">
                        <v-col cols="4" class="text-center table-head-invoice primary--text">Tipo</v-col>
                        <v-col cols="4" class="text-center table-head-invoice primary--text">Base</v-col>
                        <v-col cols="4" class="text-center table-head-invoice primary--text">Cuota</v-col>
                    </template>
                    <template v-else>
                        <v-col cols="4" class="text-center table-head-invoice primary--text">Tipo</v-col>
                        <v-col cols="4" class="text-center table-head-invoice primary--text">Base</v-col>
                        <v-col cols="4" class="text-center table-head-invoice primary--text">Cuota</v-col>
                    </template>
                    <template v-for="vat in tab.vats" >
                        <template v-if="currentCompany && show_vat(vat.vat)">
                            <template v-if="Boolean(currentDocument.metadata['detail_'+vat.vat]) && currentDocument.metadata['detail_'+vat.vat].length>0">
                                <v-col :key="'label_'+vat.vat" cols="4" class="text-center table-row-invoice">
                                    <doc-text-field 
                                        kind="text"
                                        readonly 
                                        :value="get_label(vat)" 
                                        :key="currentDocument.id.toString()+isWaitingFlow.toString()+'label_'+vat.vat"
                                    />
                                </v-col>
                                <v-col :key="'base_'+vat.vat" cols="4" class="text-center table-row-invoice">
                                    <metadata-field-detected 
                                        kind="detail_number" 
                                        :field-key="'base_'+vat.vat" 
                                        :field-check="[vat.vat,vat.coef]" 
                                        field-text="" 
                                        :key="currentDocument.id.toString()+isWaitingFlow.toString()+'base_'+vat.vat"
                                        readonly
                                    />  
                                </v-col>
                                <v-col :key="'vat_'+vat.vat" cols="4" class="text-center table-row-invoice">
                                    <metadata-field-detected 
                                        kind="detail_number" 
                                        :field-key="vat.vat" 
                                        :field-check="[vat.vat,vat.coef]" 
                                        field-text="" 
                                        :key="currentDocument.id.toString()+isWaitingFlow.toString()+vat.vat"
                                        readonly
                                    />  
                                </v-col>
                            </template>
                            <template v-else-if="currentDocument.companydb_info && currentDocument.companydb_info.companydb_type && currentDocument.companydb_info.companydb_type.type == 'invoice' && currentDocument.companydb_info.companydb_type.params && currentDocument.companydb_info.companydb_type.params.desglose_de_cuentas">
                                <v-col :key="'label_'+vat.vat" cols="4" class="table-row-invoice" >
                                    <doc-text-field 
                                        v-if="vat.vat.includes('_re_')"
                                        kind="text" 
                                        readonly 
                                        :small_font="true"
                                        :value="get_label(vat)" 
                                        :key="currentDocument.id.toString()+isWaitingFlow.toString()+'label_'+vat.vat"
                                    />
                                     <doc-text-field 
                                        v-else
                                        kind="text" 
                                        readonly 
                                        :value="get_label(vat)" 
                                        :key="currentDocument.id.toString()+isWaitingFlow.toString()+'label_'+vat.vat"
                                    />
                                </v-col>
                                <v-col :key="'vat_'+vat.vat" cols="4" class="table-row-invoice">
                                    <metadata-field-detected 
                                        kind="number" 
                                        :required="Boolean(currentDocument.metadata[vat.vat])" 
                                        :field-key="'base_'+vat.vat" 
                                        :field-check="[vat.vat,vat.coef]" 
                                        field-text="" 
                                        :key="currentDocument.id.toString()+isWaitingFlow.toString()+'base_'+vat.vat"
                                        :fill-account="vat.vat"
                                        readonly
                                    /></v-col>
                                <v-col :key="'base_'+vat.vat" cols="4" class="table-row-invoice">
                                    <metadata-field-detected 
                                        kind="number" 
                                        :required="Boolean(currentDocument.metadata['base_'+vat.vat])" 
                                        :field-key="vat.vat" 
                                        :field-check="['base_'+vat.vat,vat.coef]" 
                                        field-text="" 
                                        :key="currentDocument.id.toString()+isWaitingFlow.toString()+vat.vat"
                                        :fill-account="vat.vat"
                                        readonly
                                    /></v-col>
                            </template >
                            <template v-else>
                                <v-col :key="'label_'+vat.vat" cols="4" class="table-row-invoice">
                                    <doc-text-field 
                                        kind="text" 
                                        readonly 
                                        :value="get_label(vat)" 
                                        :key="currentDocument.id.toString()+isWaitingFlow.toString()"
                                    />
                                </v-col>
                                <v-col :key="'vat_'+vat.vat" cols="4" class="table-row-invoice">
                                    <metadata-field-detected 
                                        kind="number" 
                                        :required="Boolean(currentDocument.metadata[vat.vat])" 
                                        :field-key="'base_'+vat.vat" 
                                        :field-check="[vat.vat,vat.coef]" 
                                        field-text="" 
                                        :key="currentDocument.id.toString()+isWaitingFlow.toString()"
                                        readonly
                                    /></v-col>
                                <v-col :key="'base_'+vat.vat" cols="4" class="table-row-invoice">
                                    <metadata-field-detected 
                                        kind="number" 
                                        :required="Boolean(currentDocument.metadata['base_'+vat.vat])" 
                                        :field-key="vat.vat" 
                                        :field-check="['base_'+vat.vat,vat.coef]" 
                                        field-text="" 
                                        :key="currentDocument.id.toString()+isWaitingFlow.toString()"
                                        readonly
                                    /></v-col>
                                <template v-if="showCustomRet">
                                    <v-col v-if="typeCheckRet == 'checkbox'" :key="'check_ret_'+vat.vat" cols="2" class="table-row-invoice">
                                        <metadata-field-detected v-if="!vat.vat.includes('_re_') " :field-key="'not_ret_'+vat.vat" kind="boolean" field-text="" :key="currentDocument.id.toString()+isWaitingFlow.toString()+'checkret'" readonly/>
                                    </v-col>
                                    <v-col v-else-if="typeCheckRet == 'base'" :key="'check_ret_'+vat.vat" cols="2" class="table-row-invoice">
                                        <metadata-field-detected v-if="!vat.vat.includes('_re_') " 
                                                        :field-key="'ret_base_'+vat.vat" 
                                                        :field-check="['base_'+vat.vat,vat.coef]" 
                                                        kind="number" 
                                                        field-text="" 
                                                        :key="currentDocument.id.toString()+isWaitingFlow.toString()+'baseret'"/>
                                                        readonly
                                    </v-col>
                                </template>
                            </template>
                        </template>
                    </template>
                </v-row>
                
            </v-tab-item>
        </v-tabs-items>
        <v-row v-if="currentDocument" class="pa-4">
            <v-col cols="12" sm="6">
                <metadata-field-detected v-if="currentDocument.companydb_info && (currentDocument.companydb_info.companydb_type.params && ((!currentDocument.companydb_info.companydb_type.params.hasOwnProperty('hide')) || (currentDocument.companydb_info.companydb_type.params.hide && !currentDocument.companydb_info.companydb_type.params.hide.includes('other_amounts'))))"
                    field-key="other_amounts" 
                    kind="number" 
                    field-text="Suplidos" 
                    :key="currentDocument.id.toString()+isWaitingFlow.toString()+'other_amounts'"
                    readonly/>
                </v-col>
            <v-col cols="12" sm="6"><metadata-field-detected field-key="total_amount" kind="number" :required="true" :tabs="tabs" field-text="Total factura" :key="currentDocument.id.toString()+isWaitingFlow.toString()+'total_amount'" readonly/></v-col>
        </v-row>
    </div>
</template>

<script>
import _ from 'lodash'
import MetadataFieldDetected from './MetadataFieldDetected.vue'
import DocTextField from './DocTextField.vue'
import DetailAccounts from './DetailAccounts.vue'
import AutocompleteWithApi from './AutocompleteWithApi.vue'
import ViesValidator from './ViesValidator.vue'
import DatePicker from './DatePicker.vue'
import {mapFieldsMetadata} from "../store/vuex_utils"
import { STANDARD_LABELS_CLIENT } from "../store/constants";

import { mapActions, mapGetters, mapState } from "vuex";
import { mapFields } from 'vuex-map-fields';
import {vuexPrefix} from "../store/vuex_utils"
import { PROVIDER_SOMETHING_OPTIONS } from '../store/constants.js';
import { PROVIDER_SOMETHING_OPTIONS2 } from '../store/constants.js';
import { dateIsInPaths } from '../utils';
import { showErrorRetentionType } from "../modules/invoices/domain/Invoice"

export default {
    name:'InvocieDetectedInfo',
    components:{
        MetadataFieldDetected,
        DocTextField,
        DetailAccounts,
        AutocompleteWithApi,
        ViesValidator,
        DatePicker,
    },
    created() {
        this.accounts = [];
    },
    computed:{
        ...mapState('tax_tab', ['vat', 'igic']),
        ...mapGetters({
            currentDocument: "documents/currentDocument",
            isWaitingFlow: "documents/isWaitingFlow",
            documentFetched: 'documents/documentFetched',
            automaticPaymentAccount: 'documents/automatic_payment_account',
            automaticChargeAccount: 'documents/automatic_charge_account',
            suppliers: "get_suppliers",
            customers: "get_customers",
            userData: "me/userData",
            currentCompany:"getCurrentCompany",
            fixMotxo:'fixMotxo',
            tabs: "tax_tab/getInitialTab",
            get_retention_types: 'get_retention_types',
            permission: 'permissions/permission',
            got_feature: 'got_feature',
        }), 
        ...mapGetters('documents',['sumBasesIva','sumBasesIgic','sumBases','has_meta_igic','has_meta_iva']),
        ...mapFields('documents',vuexPrefix('document_',[
            'kind','state','bien_inversion','supplierdb','customerdb','supplierdb_info','customerdb_info','comerciante_minorista',
            'gasto_iva_percent', 'errorJson','written_description','description', 'prorate','building_code','apply_modelo', 'serie',
            'doc_number', 'retention_type_name', 'criterio_de_caja', 'written_description_sii', 'description_sii', 'payment_account', 'charge_account',
            'is_comerciante_minorista', 'inv_number_to_rectify', 'inv_date_to_rectify',
        ],'document.')),
        // ...mapFields(['showModalSupplier','showModalCustomer']),
        ...mapFields('me',vuexPrefix('',[
            'feature_comerciante_minorista', 'feature_no_sujeta', 'feature_bien_inversion', 'feature_intra_type', 'feature_extra_type', 'feature_gasto_iva_parcial',
            'feature_prorate','feature_building_code','feature_iva_deducible_parcialmente','feature_apply_347','feature_vat_5',
            'feature_search_thirds_by_api', 'feature_base_retention', 'feature_see_albaran', 'feature_customer_retention_type', 
            'feature_retention_accounts_agrario', 'feature_criterio_de_caja', 'feature_expens_account_metadata'
        ],'userData.available_features.')),
        ...mapFieldsMetadata(vuexPrefix('metadata_',STANDARD_LABELS_CLIENT.map(x=>x.name),'')),
        ...mapFields('cru',['accounts', 'label_automatic_payment_account']),
        ...mapFields('cru', vuexPrefix('cru_label_', ['payment_account', 'charge_account'], 'inputLabels.')),
        ...mapActions({
            setSuppliers: "setSuppliersPromise",
        }),
        ...mapFields('documents', ['selectedParam', 'selectedParamOption', 'selectedParamOption2', 'selectedIvaCheck']),
        currentTab:{
            get(){
                
                if(this.clickedTab!=undefined){
                    return this.clickedTab
                }else if(typeof(this.sumBasesIva)=='string'){
                    return 0
                }else if(typeof(this.sumBasesIgic)=='string'){
                    if(this.currentCompany.tax_type.includes('iva'))
                        return 1
                    else
                        return 0
                }else{
                    if(this.currentCompany && this.currentCompany.tax_type && this.currentCompany.tax_type.includes('iva') && this.currentCompany.tax_type.includes('igic')){
                        return Math.abs(this.sumBasesIva)>=Math.abs(this.sumBasesIgic)?0:1
                    }
                    return 0
                }   
            },
            set(newValue){
                if(newValue!=this.currentTab)
                    this.clickedTab=newValue
            },
        },
        errorRetentionType(){
            let missing_fields = {};
            if(this.currentDocument.errorJson){
                missing_fields = this.currentDocument.errorJson['missing_fields'];
            }
            
            let invoice = {
                state:this.currentDocument.state,
                missing_fields : missing_fields,
                retention_type_name:this.document_retention_type_name,
                retention_percent:this.currentDocument.metadata?this.currentDocument.metadata['retention_type']:false,
                retention_amount:this.currentDocument.metadata?this.currentDocument.metadata['retention_amount']:false,

            }
            return showErrorRetentionType(invoice)
        },
        typeCheckRet(){
            let type = 'none'
            if (this.currentCompany.check_ret){
                type = 'checkbox'
            }
            else if((this.feature_base_retention && this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.type == 'account_move')){
                type = 'base'
            }
            else if(this.feature_base_retention && this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.type == 'invoice'){
                if(this.currentDocument.companydb_info.companydb_type.params && this.currentDocument.companydb_info.companydb_type.params.desglose_de_cuentas){
                    type = 'detail'
                }
                else{
                    type = 'base'
                }
            }
            return type
        },
        someParamsError(){
            return this.showRequiredDescriptionSII || this.showTypes0Error
        },
        showRequiredDescriptionSII(){
            return this.currentDocument.state == 'error_missing_fields' && this.currentDocument.errorJson['missing_fields'].includes('description_sii') && !this.document_description_sii
        },
        showTypes0Error(){
            return this.currentDocument.state == 'error_checking_taxes' && this.currentDocument.errorJson.includes("type_0_incompatibilities") && this.got_feature('feature_type_0_errors') && this.selectedParam
        },
        hasSomeCustomRet(){
            for(let i in this.tabs){
                    let vats = this.tabs[i].vats
                    for(let j in vats){
                        let vat = vats[j].vat
                        let rb = 'ret_base_'+vat
                        let na = 'not_apl_ret_'+vat
                        let nr = 'not_ret_'+vat
                        if( this.currentDocument.metadata[rb] || this.currentDocument.metadata[rb]==0 || this.currentDocument.metadata[na] || this.currentDocument.metadata[nr]){
                            if(this.currentDocument.metadata[rb] != ''){ //no entenc com considera els no booleans js
                                return true
                            }
                        }
                    }
            }
            return false
        },
        showCustomRet(){
            return this.hasSomeCustomRet || this.conf_ret_button
        },
        cusRetMarginLeft(){
            return '-7%'
        },
        visibleTabs() {
            let visibleTabs = this.tabs.filter(tab => {
                if (tab.code == 'params') {
                    return this.document_supplierdb_info || this.document_customerdb_info;
                } else if (tab.code == 'iva' && this.currentCompany && this.currentCompany.tax_type) {
                    return this.currentCompany.tax_type.includes(tab.code) || this.has_meta_iva;
                } else if (tab.code == 'igic'  && this.currentCompany && this.currentCompany.tax_type) {
                    return this.currentCompany.tax_type.includes(tab.code) || this.has_meta_igic;
                } 
                return []; 
            });
            return visibleTabs
        },
        showDateErrorHover() {
            try{
                let date_fields = this.currentDocument.metadata['invoice_date'].split('/');
                if (date_fields.length == 3) {
                    let date = date_fields[2] + '-' + date_fields[1] + '-' + date_fields[0];
                    return !dateIsInPaths(date, this.currentDocument['paths']);
                }
                return false;
            }catch(e){
                return false
            }
        },
        show_third_concept() {
            return !(this.currentDocument.state=='done' && !this.currentDocument.metadata['third_concept']) && this.feature_expens_account_metadata && this.currentCompany && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params['show'] && this.currentCompany.companydb_type.params['show'].includes('expens_account_metadata') && (this.document_supplierdb_info || this.document_customerdb_info);
        },
        valid_expens_accounts() {
            let is_valid = false;
            if(this.currentDocument.companydb_info && this.currentDocument.companydb_info.companydb_type && this.currentDocument.companydb_info.companydb_type.params && this.currentDocument.companydb_info.companydb_type.params.check_expens_income_accounts){
                if (this.document_supplierdb_info && this.document_supplierdb_info['expens_accounts']) {
                    is_valid = true;
                    if (!this.document_supplierdb_info['expens_accounts'].length) {
                        is_valid = false;
                    } else {
                        for (let i in this.document_supplierdb_info['expens_accounts']) {
                            if (!this.document_supplierdb_info['expens_accounts'][i].length) {
                                is_valid = false;
                            }
                        }
                    }
                }
            }
            else{
                is_valid = true;
            }
            return is_valid;
        },
        valid_expens_account_bien_inversion() {
            let is_valid = false;
            if(this.currentDocument.bien_inversion && this.currentDocument.companydb_info && this.currentDocument.companydb_info.companydb_type && this.currentDocument.companydb_info.companydb_type.params && this.currentDocument.companydb_info.companydb_type.params.check_expens_income_accounts && !this.show_third_concept){
                if(this.document_supplierdb_info && this.document_supplierdb_info['expens_account_bien_inversion'] && this.document_supplierdb_info['expens_account_bien_inversion'].length) {
                    is_valid = true;
                }
            }
            else {
                is_valid = true;
            }
            return is_valid;
        },
        valid_income_accounts() {
            let is_valid = false;
            if(this.currentDocument.companydb_info && this.currentDocument.companydb_info.companydb_type && this.currentDocument.companydb_info.companydb_type.params && this.currentDocument.companydb_info.companydb_type.params.check_expens_income_accounts){
                if (this.document_customerdb_info && this.document_customerdb_info['income_accounts']) {
                    is_valid = true;
                    if (!this.document_customerdb_info['income_accounts'].length) {
                        is_valid = false;
                    } else {
                        for (let i in this.document_customerdb_info['income_accounts']) {
                            if (!this.document_customerdb_info['income_accounts'][i].length) {
                                is_valid = false;
                            }
                        }
                    }
                }
            }
            else{
                is_valid = true
            }
            return is_valid;
        },
        // currentPath() {
        //     let path = false;
        //     if (this.currentDocument.metadata['invoice_date'] && this.currentDocument['paths'].length) {
        //         let date_fields = this.currentDocument.metadata['invoice_date'].split('/');
        //         if (date_fields.length == 3) {
        //             let year = date_fields[2];
        //             for (let i in this.currentDocument['paths']) {
        //                 let path_year = this.currentDocument['paths'][i]['min_date'].split('-')[0];
        //                 if (year == path_year) {
        //                     path = this.currentDocument['paths'][i];
        //                 }
        //             }
        //         }
        //     }
        //     return path;
        // },
        show_retention_type_name() {
            let show = false;
            if (!(this.document_retention_type_name == 'third_value' && ['done','done_manually', 'done_with_warnings'].includes(this.currentDocument.state))) {
                let show_cdb_type = this.currentCompany && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params['show'] && this.currentCompany.companydb_type.params['show'].includes('customer_retention_type');
                if (this.document_kind == 'in_invoice' || (this.feature_customer_retention_type && show_cdb_type)) {
                    show = true;
                }
            }
            return show;
        },
        filtered_retention_types() {
            return this.get_retention_types.filter(element => {
            const isAgricultureOrLivestock = element.value === 'retention_agriculture_account' || element.value === 'retention_livestock_account';
            const isCapital = element.value === 'retention_capital_account';
            const isTransport = element.value === 'retention_transport_account';

            if ((!this.currentCompany.iva_agrario_pesca || !this.feature_retention_accounts_agrario) && isAgricultureOrLivestock) {
                return false;
            }
            if (!this.got_feature('feature_capital_retention') && isCapital) {
                return false;
            }
            if (!this.got_feature('feature_retention_accounts_transport') && isTransport) {
                return false;
            }
            return true;
            });
        },
        taxTypesDoNotMatch() {
            const valueIsFalsyOrZeroString = v => {
                if (!v) return true

                if (typeof v === 'string') {
                    const parsedValue = parseFloat(v)
                    if (!parsedValue && !_.isNaN(parsedValue)) return true
                }

                return false
            }

            const taxRegex = new RegExp('[^_\W]+')
            const vatBases = this.vat.map(e => `base_${e.vat}`)
            const igicBases = this.igic.map(e => `base_${e.vat}`)
            const metadataNoFalsies = _.pickBy(this.currentDocument.metadata, v => !valueIsFalsyOrZeroString(v)) 
            const taxType = this.selectedParamOption ? this.selectedParamOption.match(taxRegex)[0] : ''

            if (this.selectedParam !== 'intracomunitario') return false

            if (taxType === 'vat') {
                return _.intersection(vatBases, Object.keys(metadataNoFalsies)).length === 0
            } else if (taxType === 'igic') {
                return _.intersection(igicBases, Object.keys(metadataNoFalsies)).length === 0
            }
            return true
        },
        apply_modelo_label() {
            let label = 'Aplica 34';
            if (this.selectedParam == 'intracomunitario') {
                label = label + '9';
            } else {
                label = label + '7';
            }
            return label;
        },
        readOnlyThirdConcept(){
            return this.currentCompany.companydb_type.value == 'aplifisa_fiscal' && this.currentCompany.companydb_type.params && this.currentCompany.companydb_type.params.hasOwnProperty('hide') && this.currentCompany.companydb_type.params.hide.includes('expens_account_bien_inversion') && this.currentDocument.bien_inversion && this.valid_expens_account_bien_inversion
        },
        automaticPaymentAccountLabel() {
            let value = null

            if (this.automaticPaymentAccount) {
                value = this.labelArray.filter(e => e.value === this.automaticPaymentAccount)[0]
                value = value.text
            }

            return value
        },
        automaticChargeAccountLabel() {
            let value = null

            if (this.automaticChargeAccount) {
                value = this.labelArray.filter(e => e.value === this.automaticChargeAccount)[0]
                value = value.text
            }

            return value
        },
        noDeducibleCheckError() {
            return this.currentDocument && ['error_validating_data'].includes(this.currentDocument.state) && this.currentDocument.errorJson.includes('iva_igic_no_deducible');
        },
        feature_supplier_comerciante_minorista() {
            let has_perm = false;
            if (this.got_feature('feature_supplier_comerciante_minorista') && this.currentDocument.companydb_info.tax_type == 'igic') {
                has_perm = true;
            }
            return has_perm;
        },
        is_rectificativa() {
            let is_rect = false;
            if (this.currentDocument.metadata && this.currentDocument.metadata['total_amount']) {
                if (this.currentDocument.metadata['total_amount'] < 0.0) {
                    is_rect = true;
                }
            }
            return is_rect;
        },
        url_get_invoices_to_rectify() {
            let url = 'docs_for_rectify/?company_id=' + this.currentCompany.id + '&kind=' + this.document_kind;
            if (this.document_kind == 'in_invoice' && this.supplierdb_info) {
                url += '&supplier_id=' + this.supplierdb_info.id;
            } else if (this.document_kind == 'out_invoice' && this.customerdb_info) {
                url += '&customer_id=' + this.customerdb_info.id;
            }
            return url;
        },
        inv_number_to_rectify_error() {
            let error = false;
            if (
                this.currentDocument.state == 'error_missing_fields' &&
                this.currentDocument.errorJson['missing_fields'] &&
                this.currentDocument.errorJson['missing_fields'].length > 0 && 
                this.currentDocument.errorJson['missing_fields'].includes('inv_number_to_rectify')
            ) {
                error = true;
            }
            return error;
        }, 
        inv_date_to_rectify_error() {
            let error = false;
            if (
                (
                    this.currentDocument.state == 'error_missing_fields' &&
                    this.currentDocument.errorJson['missing_fields'] &&
                    this.currentDocument.errorJson['missing_fields'].length > 0 && 
                    this.currentDocument.errorJson['missing_fields'].includes('inv_date_to_rectify')
                ) || (
                    this.currentDocument.state == 'error_validating_data' &&
                    this.currentDocument.errorJson &&
                    this.currentDocument.errorJson.length > 0 &&
                    this.currentDocument.errorJson.includes('inv_date_to_rectify')
                )
            ) {
                error = true;
            }
            return error;
        }
    },
    watch: {
        selectedParam() {
            setTimeout(() => {
                this.lastSelectedParam = this.selectedParam;
            })
            if(['no_sujeta','dry_0_percent','inversion_sujeto_pasivo_igic'].includes(this.selectedParam)){
                let third_params = {}
                third_params[this.selectedParam] = true
                this.setType0(third_params)
            }
            else if(['no_sujeta','dry_0_percent','inversion_sujeto_pasivo_igic'].includes(this.lastSelectedParam)){
                let third_params = {}
                this.setType0(third_params)
            }
            this.setIntraDataFromCustom({param: this.selectedParam, value: this.selectedParamOption, value2: this.selectedParamOption2})
        },
        selectedParamOption() {
            this.setIntraDataFromCustom({param: this.selectedParam, value: this.selectedParamOption, value2: this.selectedParamOption2})
        },
        selectedParamOption2() {
            this.setIntraDataFromCustom({param: this.selectedParam, value: this.selectedParamOption, value2: this.selectedParamOption2})
        },
        selectedIvaCheck() {
            setTimeout(() => {
                this.lastSelectedIvaCheck = this.selectedIvaCheck;
            })
        },
        document_supplierdb_info(new_sup, old_sup) {
            if (((new_sup && old_sup) && (new_sup.id!=old_sup.id)) || (new_sup && !old_sup)) {
                this.updateAutomaticMoveAccounts()
                this.setType0(this.document_supplierdb_info)
                this.setIntraDataFromThirdParty(this.document_supplierdb_info);
                if(this.feature_criterio_de_caja) {
                    this.setCriteriodeCaja(this.document_supplierdb_info);
                }
                if (this.feature_supplier_comerciante_minorista) { // Es un computed que usa got_feature
                    this.setIsComercianteMinorista(this.document_supplierdb_info);
                }
                this.documentToParam();
                this.getRetentionTypeFromThird();
            }
        },
        document_customerdb_info(new_cus, old_cus) {
            if (((new_cus && old_cus) && (new_cus.id!=old_cus.id)) || (new_cus && !old_cus)) {
                this.updateAutomaticMoveAccounts()
                this.setType0(this.document_customerdb_info)
                this.setIntraDataFromThirdParty(this.document_customerdb_info);
                this.documentToParam();
                this.getRetentionTypeFromThird();
            }
        },
    },
    methods:{
        ...mapActions("cru", ['getAccounts']),
        ...mapActions("cookies", ['initialThirdPartyValuesModal', 'setThirdPartyPosition']),
        ...mapActions("documents", ['updateAutomaticMoveAccounts']),
        currentPath() {
            let path = false;
            let year = false;
            let date_fields = false;
            if(this.currentDocument.accounting_date_config=='invoice_date'){
                date_fields = this.currentDocument.metadata['invoice_date'].split('/');
            }
            if(this.currentDocument.accounting_date_config=='today'){
                let today = new Date();
                date_fields = [today.getDate(), (today.getMonth() + 1), today.getFullYear()];
            }
            if(this.currentDocument.accounting_date_config=='configurated'){
                date_fields = this.currentDocument.default_accounting_date.split('/');
            }
            if (date_fields && date_fields.length == 3) {
                year = date_fields[2];
            }
            if (year && this.currentDocument['paths'].length) {
                for (let i in this.currentDocument['paths']) {
                    let path_year = this.currentDocument['paths'][i]['min_date'].split('-')[0];
                    if (year == path_year) {
                        path = this.currentDocument['paths'][i];
                    }
                }
            }
            return path;
        },
        get_label(vat){
            if(vat.vat == 'vat_0'){
                if(!this.got_feature('feature_exenta_no_sujeta')){
                    return '0%'
                }
                else if(this.currentDocument.intracomunitario){
                    return '0% Intra'
                }
                else if(this.currentDocument.extracomunitario){
                    return '0% Extr.'
                }
                else if(this.currentDocument.inversion_sujeto_pasivo_iva){
                    return '0% ISP'
                }   
            }
            else if(vat.vat == 'igic_0'){
                if(!this.got_feature('feature_exenta_no_sujeta')){
                    return '0%'
                }
                else if(this.currentDocument.intracomunitario){
                    return '0% Intra'
                }
                else if(this.currentDocument.extracomunitario){
                    return '0% Extr.'
                }
                else if(this.currentDocument.inversion_sujeto_pasivo_igic){
                    return '0% ISP'
                }   
                else if (this.currentDocument.is_comerciante_minorista) {
                    return '0% CM'
                }
            }
            return vat.label
        },
        show_vat(vat){
            if(['vat_10_5','vat_12'].includes(vat) && !this.currentCompany.iva_agrario_pesca){
                return false
            }
            if(['vat_re_1_75'].includes(vat) && !this.currentCompany.iva_tabaco){
                return false
            }
            if(['vat_5'].includes(vat) && !this.feature_vat_5){
                return false
            }
            if(['vat_ns_0','vat_ne_0','igic_ns_0','igic_ne_0'].includes(vat) && !this.got_feature('feature_exenta_no_sujeta')){
                return false
            }
            if(['vat_re_625'].includes(vat) && !this.got_feature('feature_vat_re_625')){
                return false
            }
            if (['igic_5'].includes(vat) && !this.got_feature('feature_igic_5')) {
                return false
            }
            return true
        },
        toggleParam() {
            this.setDirty()
            if (this.selectedParam == this.lastSelectedParam) {
                this.selectedParam = undefined
            }
        },
        resetParamOption() {
            this.selectedParamOption = undefined;
            this.selectedParamOption2 = undefined;
        },
        toggleParamIva() {
            if (this.selectedIvaCheck == this.lastSelectedIvaCheck) {
                this.selectedIvaCheck = undefined;
            }
            this.document_comerciante_minorista = false;
            this.document_gasto_iva_percent = 50;
        },
        ...mapActions({
            setIntraDataFromThirdParty: "documents/setIntraDataFromThirdParty",
            setCriteriodeCaja: "documents/setCriteriodeCaja",
            setIsComercianteMinorista: "documents/setIsComercianteMinorista",
            setIntraDataFromCustom: "documents/setIntraDataFromCustom",
            setDirty: "documents/setDirty",
            documentToParam: "documents/documentToParam",
            setType0: "documents/setType0"
        }),
        show_modal(){
            this.initialThirdPartyValuesModal();
            if(this.document_kind=='in_invoice'){
                // this.showModalSupplier = true
                this.$modal.show('modal-supplier');
            }
            else{
                // this.showModalCustomer = true
                this.$modal.show('modal-customer');
            }
        },
        setSupplierAccount(){
            if (this.currentDocument.supplierdb_info && this.currentDocument.companydb_info && this.currentDocument.companydb_info.companydb_type && this.currentDocument.companydb_info.companydb_type.type == 'invoice' && this.currentDocument.companydb_info.companydb_type.params && this.currentDocument.companydb_info.companydb_type.params.desglose_de_cuentas) {
                for(let i in this.tabs){
                    let vats = this.tabs[i].vats
                    for(let j in vats){
                        let vat = vats[j].vat
                        if(this['metadata_base_'+vat] || this['metadata_'+vat] || this['metadata_account_'+vat]){
                            this['metadata_account_'+vat] = this.currentDocument.supplierdb_info.expens_accounts[0]
                        }
                    }
                }
            }
        },
        setCustomerAccount(){
            if (this.currentDocument.companydb_info && this.currentDocument.companydb_info.companydb_type && this.currentDocument.companydb_info.companydb_type.type == 'invoice' && this.currentDocument.companydb_info.companydb_type.params && this.currentDocument.companydb_info.companydb_type.params.desglose_de_cuentas) {
                for(let i in this.tabs){
                    let vats = this.tabs[i].vats
                    for(let j in vats){
                        let vat = vats[j].vat
                        if(this['metadata_base_'+vat] || this['metadata_'+vat] || this['metadata_account_'+vat]){
                            this['metadata_account_'+vat] = this.currentDocument.customerdb_info.income_accounts[0]
                        }
                    }
                }
            }
        },
        on_supplierdb_changed() {
            this.setType0(this.document_supplierdb_info)
            this.setIntraDataFromThirdParty(this.document_supplierdb_info);
            if(this.feature_criterio_de_caja) {
                this.setCriteriodeCaja(this.document_supplierdb_info);
            }
            if (this.feature_supplier_comerciante_minorista) { // Es un computed que usa got_feature
                this.setIsComercianteMinorista(this.document_supplierdb_info)
            }

            this.documentToParam()
            this.setDirty();
            this.setSupplierAccount()
            this.getRetentionTypeFromThird();
        },
        on_customerdb_changed() {
            this.setType0(this.document_customerdb_info)
            this.setIntraDataFromThirdParty(this.document_customerdb_info);
            this.documentToParam();
            this.setDirty();
            this.setCustomerAccount();
            this.getRetentionTypeFromThird();
        },
        filterBy(item, queryText, itemText) {
            const text = item.selector_text.toLowerCase();
            const searchText = queryText.toLowerCase();
            return text.indexOf(searchText) > -1;
        },
        get_tipo_cols(){
            if(!this.showCustomRet)
                return 4
            else{
                return 3
            }
        },
        get_cuota_cols(){
            if(!this.showCustomRet)
                return 4
            else{
                return 3
            }
        },
        canChange() {
            const STATES = [
                'pending_connect',
                'done',
                'done_manually',
                'accounting_aplifisa_fiscal',
                'accounting_invoice',
                'done_with_warning',
                'pending_sync',
                'pending_upload',
            ];
            return Boolean(!(this.currentDocument && (this.isWaitingFlow || STATES.includes(this.currentDocument.state))) || this.fixMotxo);
        },
        getRetentionTypeFromThird() {
            if (this.document_kind == 'in_invoice') {
                if (this.document_supplierdb_info && this.document_supplierdb_info['retention_type']) {
                    if (this.document_supplierdb_info['retention_type'] == 'retention_professional_start_act_account') {
                        this.document_retention_type_name = 'retention_professional_account'
                    } else {
                        this.document_retention_type_name = this.document_supplierdb_info['retention_type'];
                    } 
                }
            } else if (this.document_kind == 'out_invoice' && this.feature_customer_retention_type) {
                if (this.document_customerdb_info && this.document_customerdb_info['retention_type']) {
                    if (this.document_customerdb_info['retention_type'] == 'retention_professional_start_act_account') {
                        this.document_retention_type_name = 'retention_professional_account'
                    } else {
                        this.document_retention_type_name = this.document_customerdb_info['retention_type'];
                    } 
                }
            }
        },
        getValues(params) {
            this.getAccounts(params).then(() => {});
        },
        resetItems(params) {
            this.accounts = params;
        },
        checkBienInversion() {
            this.setDirty()
            if (this.show_third_concept && this.currentDocument.companydb_info.companydb_type.value === 'aplifisa_fiscal'){
                if (this.document_bien_inversion){
                    this.metadata_third_concept="200";
                }
                else if(!this.document_bien_inversion && this.document_supplierdb_info && this.document_supplierdb_info['expens_accounts']){
                    this.metadata_third_concept=this.document_supplierdb_info['expens_accounts'][0]
                }
            }
        },
        changeInvNumberToRectify() {
            if (typeof this.invoice_to_rectify == 'object') {
                this.document_inv_number_to_rectify = this.invoice_to_rectify['inv_number'];
                this.document_inv_date_to_rectify = this.invoice_to_rectify['metadata']['invoice_date'];
            } else {
                this.document_inv_number_to_rectify = this.invoice_to_rectify;
            }
        },
    },
    data(){
        return {
            show_account_detail:false,
            dialog_vat:'',
            PROVIDER_SOMETHING_OPTIONS,
            PROVIDER_SOMETHING_OPTIONS2,
            clickedTab: undefined,
            // selectedParam: undefined,
            // lastSelectedParam: undefined,
            // selectedParamOption: undefined,
            supps: [],
            conf_ret_button:false,
            labelArray: [{'text': 'N/A', 'value': 'na'}, {'text': 'Si', 'value': 'y'}, {'text': 'No', 'value': 'n'}],
            declined_matching:false,
            invoice_to_rectify: '',
        }
    },
    mounted() {
        if (this.selectedParam) {
            this.lastSelectedParam = this.selectedParam;
        }
        if (this.selectedIvaCheck) {
            this.lastSelectedIvaCheck = this.selectedIvaCheck;
        }
        if (!['done','done_manually', 'done_with_warning'].includes(this.currentDocument.state) && this.document_retention_type_name == 'third_value') {
            this.getRetentionTypeFromThird();
        }
        if (this.document_inv_number_to_rectify) {
            this.invoice_to_rectify = this.document_inv_number_to_rectify;
        }
    },
    
}
</script>

<style scoped>
    .table-head-invoice {
        border-left-style:solid;
        border-right-style:solid;
        border-bottom-style:solid;
        border-color:#663399;
        border-width: thin;
    }
    .table-row-invoice {
        border-left-style:solid;
        border-right-style:solid;
        border-bottom-style:solid;
        border-color:#663399;
        border-width: thin;
    }
    div.table-iva > div > div {
        border-top-style:solid;
        border-color:#663399;
        border-width: thin;
    }
    .table-row-invoice >>> div > .row > .col > div > .v-text-field {
        margin-top: 0px;
    }
    .table-row-invoice >>> div > .v-text-field {
        margin-top: 0px;
    }
    .table-row-invoice >>> div > .row > .col > div > .v-text-field > .v-input__control > .v-input__slot {
        height: 36px;
    }
    .table-row-invoice >>> div > .v-text-field > .v-input__control > .v-input__slot {
        height: 36px;
    }
</style>
